import { Paper } from "@mui/material";

import type { SectionSpec } from "@/shared/models/SectionSpec";
import { M1SectionDetailsPanel } from "./M1SectionDetailsPanel";

interface ReferencesProps {
	sectionId: number | null;
	spec: SectionSpec | null;
}

export const References = ({ sectionId, spec }: ReferencesProps) => (
	<Paper
		component="aside"
		aria-label="Test Shack references"
		elevation={2}
		sx={{
			p: 1.5,
			minWidth: 0,
			height: { xs: "auto", md: "100%" },
			overflow: { xs: "auto", md: "hidden" },
			boxSizing: "border-box",
			minHeight: 0,
		}}
	>
		<M1SectionDetailsPanel sectionId={sectionId} spec={spec} />
	</Paper>
);
